import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const Wrapper = styled.div`
  @media print {
    min-height: 0px;
  }
  max-width: ${({ theme }) => theme.page.maxWidth}px;
  margin: auto;
  min-height: 100%;
  background-color: ${({ theme }) => theme.page.bgColor};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 16px 0px;
  overflow: hidden;
`;

const OneCol = ({ className, children }) => {
  const classes = ["OneCol"];
  if (className) classes.push(className);

  return <Wrapper className={classes.join(" ")}>{children}</Wrapper>;
};

OneCol.displayName = "OneCol";

OneCol.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

OneCol.defaultProps = {
  className: null,
};

export default OneCol;

export const Row = styled.div`
  margin-bottom: ${({ theme }) => theme.spacer * 3}px;
  background-color: ${({ bgColor, theme }) =>
    theme.palette.background[bgColor]};

  ${({ bgColor, theme }) =>
    bgColor &&
    css`
      border-top: 1px solid ${theme.palette.darker};
      border-bottom: 1px solid ${theme.palette.darker};
    `}

  ${({ fullWidth, theme, bgColor }) =>
    fullWidth
      ? css`
          padding: ${bgColor ? theme.spacer * 1.5 : 0}px 0;
        `
      : css`
          padding: ${bgColor ? theme.spacer * 3 : 0}px ${theme.spacer * 1.5}px;
        `}

  ${({ theme }) => theme.mediaQueries.medium} {
    margin-bottom: ${({ theme }) => theme.spacer * 4}px;
    ${({ fullWidth, theme, bgColor }) =>
      fullWidth
        ? css`
            padding: ${bgColor ? theme.spacer * 4 : 0}px 0;
          `
        : css`
            padding: ${bgColor ? theme.spacer * 4 : 0}px ${theme.spacer * 4}px;
          `}
  }
`;
